import { adHocRequestListSchema, adHocRequestSchema, adHocRequestSummarySchema, type AdHocRequestInput, type AdHocRequestList, type AdHocRequestSummary } from '@vigeo/shared';
import { z } from 'zod';
import { fixtureMode } from '../../lib/data-mode.js';

async function read<T>(response: Response, schema: z.ZodType<T>): Promise<T> {
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const error = typeof body === 'object' && body !== null && 'error' in body && typeof body.error === 'string' ? body.error : 'The request could not be completed.';
    throw new Error(error);
  }
  return schema.parse(body);
}

/** The person's one-off document requests, newest first. */
export async function fetchAdHocRequests(personId: string): Promise<AdHocRequestList> {
  if (fixtureMode) return { requests: [] };
  return read(await fetch(`/api/people/${encodeURIComponent(personId)}/requests`), adHocRequestListSchema);
}

/** Create one; the same `operationId` twice is the same request. */
export async function createAdHocRequest(personId: string, input: AdHocRequestInput): Promise<AdHocRequestSummary> {
  if (fixtureMode) throw new Error('Requests need the local test API; design fixtures are read-only.');
  const response = await fetch(`/api/people/${encodeURIComponent(personId)}/requests`, {
    method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(adHocRequestSchema.parse(input)),
  });
  return (await read(response, z.object({ request: adHocRequestSummarySchema }))).request;
}
